import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const n = e([
  "paginationBase",
  "paginationButtons",
  "paginationContainer",
  "paginationSize"
]), i = n.defineMultiStyleConfig({
  baseStyle: {
    paginationBase: {
      display: "inline-flex",
      gap: 2,
      "> li": {
        display: "inline-block",
        _focusWithin: {
          boxShadow: "outline",
          borderRadius: "lg"
        }
      },
      "> li:not(.previous):not(.next)": {
        display: "none"
      },
      "> li.disabled > a > div": {
        opacity: 0.5,
        cursor: "not-allowed",
        boxShadow: "none"
      },
      "> li a": {
        _focusVisible: {
          outline: "none"
        }
      }
    },
    paginationButtons: {
      textStyle: "bodySmall",
      gap: 6,
      justifyContent: { base: "space-between", md: "flex-end" },
      alignItems: "center",
      width: "100%"
    },
    paginationContainer: {
      gap: 2,
      flexDirection: { base: "column", md: "row" },
      justifyContent: "space-between",
      paddingY: 3,
      paddingX: 6,
      backgroundColor: "white"
    },
    paginationSize: {
      textStyle: "bodySmall",
      alignItems: "center",
      justifyContent: { base: "space-between", md: "flex-start" },
      gap: 2,
      width: "100%"
    }
  }
});
export {
  i as default
};
